// v0.52 — the home greeting. A short, warm, curious line chosen by local time
// of day (never salesy), rotating within its slot so two mornings don't read the
// same. The money-question ("What do you want your money to do?") lives beneath
// it as the constant frame for the action tiles.
//
// The dynamic hook is stubbed now (only the clock feeds it), but it's the seam
// where the good stuff lands later: "Your money earned $0.12 overnight ✨" when
// MMF interest posts, or a portfolio mover — greetings quietly doing funnel work.

const MORNING = ["Early start?", "Busy morning?", "Morning.", "Fresh start?"];
const MIDDAY = ["How's your day going?", "Good afternoon.", "Back again?"];
const EVENING = ["Evening.", "How was your day?", "Winding down?"];
const LATE = ["Still up?", "Late one?"];

const LAST_KEY = "m.greetLast";

function slotFor(h: number): string[] {
  if (h < 5) return LATE;
  if (h < 12) return MORNING;
  if (h < 17) return MIDDAY;
  if (h < 22) return EVENING;
  return LATE;
}

/** Pick from the pool, avoiding the immediately-previous line where possible. */
function rotate(pool: string[]): string {
  let last = "";
  try {
    last = localStorage.getItem(LAST_KEY) || "";
  } catch {
    /* storage blocked — fall through to a plain random pick */
  }
  const choices = pool.length > 1 ? pool.filter((p) => p !== last) : pool;
  const pick = choices[Math.floor(Math.random() * choices.length)];
  try {
    localStorage.setItem(LAST_KEY, pick);
  } catch {
    /* ignore */
  }
  return pick;
}

/**
 * v1 dynamic hook — returns a contextual greeting when there's something worth
 * saying (MMF interest posted, a portfolio mover, a streak…), else null so the
 * clock-based line is used. Stubbed to null for now; the seam is what matters.
 */
export function dynamicGreeting(): string | null {
  return null;
}

/** The greeting to show now: a dynamic line if there is one, else time-of-day. */
export function greetingFor(now: Date = new Date()): string {
  return dynamicGreeting() ?? rotate(slotFor(now.getHours()));
}

/** The constant line beneath the greeting. */
export const MONEY_QUESTION = "What do you want your money to do?";
